import React from 'react'
import ReportWrapper from '../ReportWrapper'
import ItemWrapper from '../../../components/ItemWrapper'
import ReportItem from '../ReportItem'
import ReportSectionHeading from '../ReportSectionHeading'
import { Stack, Text } from '@mantine/core'
import { useTheme } from '../../../components/ThemeProvider'

interface BadInformationDetectionProps {
  data: any
  title: string
  sectionIndex?: string
}

const getBadInfoLevel = (score: number) => {
  if (score >= 80) return '严重不良记录'
  if (score >= 60) return '中度不良记录'
  if (score >= 40) return '一般不良记录'
  if (score >= 20) return '涉稳或涉恐不良记录'
  if (score > 0) return '其他不良记录'
  return '无不良信息'
}

export default function BadInformationDetection({ data, title, sectionIndex }: BadInformationDetectionProps) {
  const theme = useTheme()
  const badInfoScore = Number.parseInt(data?.bad_info_score ?? '0', 10)
  const hit = Number.parseInt(data?.bad_info_hit ?? '0', 10) === 1

  return (
    <ReportWrapper>
      <ReportSectionHeading title={title} index={sectionIndex} />
      <ItemWrapper className="mt-2">
        <Stack gap="md">
          <div>
            <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
              不良信息检测
            </Text>
            <Text size="xs" className="text-gray-500" style={{ marginTop: '4px' }}>
              数据来源于合作数据源的不良记录监测，用于排查涉稳、涉恐及违法行为。
            </Text>
          </div>
          <ReportItem name="是否命中不良信息" value={hit ? '是' : '否'} isNormal={!hit} />
          <ReportItem name="不良等级" value={getBadInfoLevel(badInfoScore)} isNormal={badInfoScore < 20} />
        </Stack>
      </ItemWrapper>
    </ReportWrapper>
  )
}
